import {jsonp} from 'vue-jsonp'

export function getCityList() {
    return jsonp('https://apis.map.qq.com/ws/district/v1/list?key=SGVBZ-4RO34-NB2US-DQKYK-ZEUVJ-4KFZF')
}


export function getCityInfo() {
    return jsonp('https://apis.map.qq.com/ws/location/v1/ip?key=SGVBZ-4RO34-NB2US-DQKYK-ZEUVJ-4KFZF', {
        output: 'jsonp',
        callbackName: 'callBack'
    })
}
